export default "__VITE_ASSET__Dj1S5z_a__"